import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/jobs/create',
        name: 'jobs.create',
        component: () => import('@/views/Job/Create.vue'),
    },
];

export default routes;
